import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { catchError, Observable, of, retry, tap, throwError, timer } from 'rxjs';
import { OrganizationService } from 'app/services/organization.service';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly organizationService: OrganizationService,
    private readonly router: Router,
    private auth0Service: AuthService
  ) { }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Clone the request object
    let newReq = req.clone();
    if (!req.url.match(`https://${environment.auth0.domain}`)) {
      newReq = req.clone({
        setHeaders: {
          'X-Organization-Id': this.organizationService.organizationSelectedId,
        },
      });
    }
    // Response
    return next.handle(newReq).pipe(
      tap({
        error: (error) => {
          if (error instanceof HttpErrorResponse && error.status === 400) {
            console.error('---400---');
          }
          if (error instanceof HttpErrorResponse && (error.status === 0 || error.status === 404)) {
            console.error('---0---404----');
            //location.replace('404-not-found');
          }
          if (error instanceof HttpErrorResponse && error.status === 504) {
            console.error('---504---');
            //this.router.navigateByUrl('/404-not-found');
          }
          if (error instanceof HttpErrorResponse && error.status === 500) {
            // this.router.navigateByUrl('errors/error');
          }
          if (error instanceof HttpErrorResponse && error.status === 401) {
            console.error('---401---');
            this.auth0Service.loginWithRedirect();
          }
        }
      }),
      // retry({ count: 1, delay: 1000 }),
      retry({
        count: 1,
        delay: (error) => {
          if (error.status === 400 || error.status === 404) {
            return throwError(() => error); // just return an observable with the error.
          }
          return timer(1000); // Retry
        },
      }),
    );
  }
}
